import ModernApiController from "./api/ModernApiController";

interface ApplicationStateGet {
    value: string;
}

/**
 * Sets a value the user application state
 * @param key key of the value
 * @param value The value
 * @returns
 */
export function set(key: string, value: string): Promise<void> {
    return ModernApiController.putAsync(`users/me/application_state/${key}`, {
        value: value
    });
}

/**
 * Gets a value from the user application state
 * @param key key of the value
 * @returns the value
 */
export async function get(key: string): Promise<string> {
    return (await ModernApiController.getAsync<ApplicationStateGet>(`users/me/application_state/${key}`)).value;
}

/**
 * Remove a value from the user application state
 * @param key key of the value
 * @returns
 */
export async function remove(key: string): Promise<void> {
    ModernApiController.deleteAsync(`users/me/application_state/${key}`);
}
